import React, { PureComponent } from 'react';
import { BASE_URL, WEBSOCKET_URL, HTTP_URL } from '../constants';
import { getImage, getTimeDiff, api } from '../utils';
import { ChatOption, SocketChat, _Chat } from './models';
import DropdownFilter from '../CommonComponents/Dropdown';
import NoUserChat from '../assets/imgs/no_user_chats.svg';
import NoUserThumbsUp from '../assets/imgs/no_user_thumbs_up.svg';
import NoBotChats from '../assets/imgs/no_user_bot_chats.svg';
import EndedChats from './EndedChats';
import Whatsapp_channel from '../assets/icons/whatsapp_channel.svg';
import Webs_channel from '../assets/icons/webs_channel.svg';
import _moment, { Moment } from 'moment';
import { extendMoment } from 'moment-range';
import Loader from '../assets/icons/loader.svg';
import refreshImage from '../assets/icons/refresh.svg';
import { any } from 'prop-types';
import { thisExpression } from '@babel/types';
type Props = {
	redirectionToLoginPage: Function;
	userDetails: any;
	chats: _Chat[];
	addChats: Function;
	selectChat: Function;
	selectedChatIndex: number;
	redirectionTab: number;
	displayChatMessage: any;
	chatRedirection: string;
	chatCoversationHistory: Function;
	showTitleNotification: Function;
	setNotificationInterval: Function;
	clearNotificationInterval: Function;
	getGroupingFormatDate: Function;
	showEndedChatData: Function;
	getUserDetails: Function;
	showEndedChats: any;
	notificationToaster?: Function;
	showUserLoader: Function;
	showChats: Function;
	noChatsSelected: boolean;
	showScreen: string;
	tenantId: number;
	// showNotification:Function;
	setIsEndedChatsSelected: (cal: boolean) => void;
	setIsBotChatsSelected: (cal: boolean) => void;
	setchatTab: (cal: number) => void;
	getAllBotChats: Function;
	allbotChats: any;
	botChatsCount: number;
	botsChatsPage: number;
	setbotsChatsPage: Function;
};
type State = {
	intervalSetting: any;
	oldChats: any;
	selectedOldChatIndex: number | any;
	selectedBotChatIndex: number;
	oldChatsPage: number;
	isOldChatsLoading: boolean;
	oldChatsExhausted: boolean;
	sessionID: string;
	selectedChatTab: number;
	selectedChatTypeIndex: number | undefined;
	botFilter: any;
	queueFilter: any;
	botFilterSelected: string;
	queueFilterSelected: string;
	myChatsTypeSelected: string;
	slectedChatData: number;
	botList: { botName: string; botid: string; botIconUrl: string }[];
	botListSelected: { botName: string; botid: string; botIconUrl: string }[];
	tabsChanged: number;
	startDate: Moment;
	endDate: Moment;
	initialstartDate: Moment;
	initialendDate: Moment;
	clearDateFilterValue: boolean;
	chatLength: number;
	isqueueLength: number;
	showQueue: boolean;
	prevQueueLength: number;
	prevBotChatsLength: number;
	isBotChatsLength: number;
	queueData: any;
	data: any;
	noDataShow: string;
	groupOldData: boolean;
	chats: _Chat[];
	callEnded: boolean;
	selectedDate: any;
	isSocketLoading: boolean;
};
let fetchedPageNumber = 0;

export default class ChatTab extends PureComponent<Props, State> {
	private myRef: React.RefObject<HTMLInputElement>;
	// interval:any|number;
	socket: WebSocket | undefined;
	// @ts-ignore
	moment = extendMoment(_moment);

	constructor(props: Props) {
		super(props);
		this.state = this.setInitialState();
		this.myRef = React.createRef();
		this.chatTypeChangeHandler = this.chatTypeChangeHandler.bind(this);
		this.handleMyChatsTypeSelectionChange =
			this.handleMyChatsTypeSelectionChange.bind(this);
		this.getOldChats = this.getOldChats.bind(this);
		this.handleEndedChatClick = this.handleEndedChatClick.bind(this);
		this.handleBotChatClick = this.handleBotChatClick.bind(this);
		this.enddateSelection = this.enddateSelection.bind(this);
		this.clearDateFilter = this.clearDateFilter.bind(this);
		this.newhandelCutomerNotification =
			this.newhandelCutomerNotification.bind(this);
		this.handleSocketClose = this.handleSocketClose.bind(this);
		this.handleOpenFailSocket = this.handleOpenFailSocket.bind(this);
		this.groupAll = this.groupAll.bind(this);
		this.endedChatcleanDate = this.endedChatcleanDate.bind(this);
		this.endedChatgetUTCData = this.endedChatgetUTCData.bind(this);

		this.heartbeat = this.heartbeat.bind(this);
		// this.sleep = this.sleep.bind(this);
		// this.runSession = this.runSession.bind(this);
		// this.chatListSocketListener = this.chatListSocketListener.bind(this);
	}

	componentDidMount() {
		if (this.props.selectedChatIndex || this.props.redirectionTab) {
			this.setState({
				slectedChatData: this.props.redirectionTab
					? this.acceptedChats.length
					: this.props.selectedChatIndex,
			});
		}
		document.addEventListener('socketClose', this.handleSocketClose);
		document.addEventListener('socketFailOpen', this.handleOpenFailSocket);

		// if (this.myRef.current) {
		//   this.myRef.current.addEventListener('scroll', this.handleBotChatsScroll);
		// }
		if (this.props.showScreen === 'HybridScreen') {
			// console.log('new socket opening');
			this.setupCustomerListener();
		}

		// changed

		// this.getBotFilter();
		// this.getQueueFilter();
	}

	handleSocketClose() {
		if (this.socket && this.socket.readyState === WebSocket.OPEN) {
			this.socket.close(1000, 'wsConnendpoint closing from UI');
		}
	}
	handleOpenFailSocket() {
		if (sessionStorage.getItem('iswsConnendpoint') === 'opened') {
			// console.log('Failed wsconnendpoint opened again');
			this.setupCustomerListener();
		}
	}
	componentDidUpdate(prevProps: Props, prevState: State) {
		if (this.myRef.current) {
			this.myRef.current.addEventListener('scroll', this.handleBotChatsScroll);
		}
		if (
			this.props.selectedChatIndex >= this.props.botChatsCount &&
			this.state.selectedChatTab === 2
		) {
			this.props.selectChat(
				this.props.redirectionTab ? this.acceptedChats.length : 0
			);
		}

		if (
			sessionStorage.getItem('startsessionID') &&
			this.props.selectedChatIndex >= this.acceptedChats.length &&
			this.state.selectedChatTab === 1
		) {
			this.props.selectChat(
				this.props.redirectionTab &&
					this.acceptedChats.length !== this.props.selectedChatIndex
					? this.acceptedChats.length
					: 0
			);
		}

		if (
			sessionStorage.getItem('startsessionID') &&
			this.state.selectedChatTab === 1
		) {
			this.acceptedChats.map((chat, index) => {
				if (
					sessionStorage.getItem('startsessionID') ===
					this.acceptedChats[index].sessionID
				) {
					// debugger;

					this.props.selectChat(
						this.props.redirectionTab ? index : this.acceptedChats.length
					);
					setTimeout(() => {
						sessionStorage.removeItem('startsessionID');
					}, 1000);
					// if (this.props.redirectionTab) {
					//   var chatsDiv = document.querySelector('.chats');
					//   chatsDiv &&
					//     chatsDiv.scroll({
					//       top: chatsDiv.scrollHeight,
					//       behavior: 'smooth',
					//     });
					// }
				}
			});
		}

		if (prevProps.redirectionTab !== this.props.redirectionTab) {
			// this.props.selectChat(this.acceptedChats.length);

			this.setState(
				{
					selectedChatTab: 1,
					slectedChatData: this.props.redirectionTab
						? this.acceptedChats.length
						: this.props.selectedChatIndex,
				},
				() => {
					this.props.selectChat(
						this.props.redirectionTab
							? this.acceptedChats.length
							: this.props.selectedChatIndex
					);
					this.props.setchatTab(this.state.selectedChatTab);
					this.props.setIsBotChatsSelected(false);
				}
			);
		}

		if (prevProps.selectedChatIndex !== this.props.selectedChatIndex) {
			this.setState(
				{
					slectedChatData: this.props.selectedChatIndex,
				},
				() => {
					this.props.selectChat(this.props.selectedChatIndex);
				}
			);
		}

		if (
			prevState.myChatsTypeSelected !== this.state.myChatsTypeSelected &&
			this.state.myChatsTypeSelected === 'Ongoing chats'
		) {
			fetchedPageNumber = 0;
			this.setState(
				{
					oldChats: [],
					oldChatsExhausted: false,
					isOldChatsLoading: false,
					selectedOldChatIndex: `-1`,
					oldChatsPage: 1,
					myChatsTypeSelected: 'Ongoing chats',
				},
				() => {
					this.props.showChats(true);
				}
			);
		}

		if (this.state.myChatsTypeSelected === 'Ended chats') {
			if (prevState.selectedChatTab !== this.state.selectedChatTab) {
				if (this.state.selectedChatTab !== 1) {
					this.props.setIsEndedChatsSelected(false);
				} else {
					this.props.setIsEndedChatsSelected(true);
				}
			}
		}
		if (prevState.selectedChatTab !== this.state.selectedChatTab) {
			fetchedPageNumber = 0;
			this.setState({
				oldChats: [],
				oldChatsExhausted: false,
				isOldChatsLoading: false,
				selectedOldChatIndex: `-1`,
				oldChatsPage: 1,
				myChatsTypeSelected: 'Ongoing chats',
			});
		}
		if (
			prevState.selectedChatTab !== this.state.selectedChatTab &&
			this.state.selectedChatTab !== 1 &&
			this.state.selectedChatTab !== 2
		) {
			// console.log('get 1');
			this.getBotFilter();
		}
		if (prevState.botFilterSelected !== this.state.botFilterSelected) {
			this.getQueueFilter();
		}
		if (prevState.tabsChanged !== this.state.tabsChanged) {
			// console.log('get 2');
			this.setState({
				botFilterSelected: '',
				queueFilterSelected: '',
			});
		}
		if (this.state.chatLength === 0) {
			this.props.userDetails.userName = '';
			this.props.userDetails.userEmail = '';
			this.props.userDetails.userContact = '';
			this.props.userDetails.userSource = '';
			this.props.userDetails.feedbackComment = '';
			this.props.userDetails.time = '';
			this.props.userDetails.sessionId = '';
		}
	}

	componentWillUnmount() {
		document.removeEventListener('socketClose', this.handleSocketClose);
		document.removeEventListener('socketFailOpen', this.handleOpenFailSocket);

		this.props.setIsEndedChatsSelected(false);
		this.props.setIsBotChatsSelected(false);
	}

	handleBotChatsScroll = (e: Event) => {
		const target = e.target as HTMLDivElement;

		let ceiloffset = Math.ceil(target.scrollTop) + target.offsetHeight;
		let flooroffset = Math.floor(target.scrollTop) + target.offsetHeight;
		// console.log(
		//   `ceilOffset , flooroffset: ${ceiloffset}, ${flooroffset}, scrollHeight: ${target.scrollHeight}`
		// );
		if (
			ceiloffset >= target.scrollHeight ||
			flooroffset >= target.scrollHeight
		) {
			this.props.getAllBotChats(this.props.botsChatsPage, true);
		}
	};
	setInitialState(): State {
		return {
			oldChats: [],
			selectedOldChatIndex: `-1`,
			selectedBotChatIndex: -1,
			oldChatsPage: 1,

			isOldChatsLoading: false,
			oldChatsExhausted: false,
			sessionID: '',
			selectedChatTab: sessionStorage.getItem('roleId') === '1' ? 1 : 0,
			selectedChatTypeIndex: undefined,
			botFilter: [],
			queueFilter: [],
			botFilterSelected: '',
			queueFilterSelected: '',
			myChatsTypeSelected: 'Ongoing chats',
			slectedChatData: 0,
			botList: [],
			botListSelected: [],
			tabsChanged: 0,
			startDate: this.moment()
				.clone()
				.subtract(2, 'year')
				.subtract(4, 'months'),
			endDate: this.moment().clone(),
			initialstartDate: this.moment()
				.clone()
				.subtract(2, 'year')
				.subtract(4, 'months'),
			initialendDate: this.moment().clone(),
			clearDateFilterValue: true,
			chatLength: 0,
			isqueueLength: 0,
			showQueue: true,
			prevQueueLength: 0,
			queueData: [],
			prevBotChatsLength: 0,
			isBotChatsLength: 0,
			data: [],
			intervalSetting: 0,
			noDataShow: '',
			groupOldData: false,
			chats: [],
			// allbotChats: [],
			callEnded: false,
			selectedDate: '',
			isSocketLoading: false,
		};
	}
	getChatFilterSelection(): string {
		const index = this.state.selectedChatTypeIndex;
		if (typeof index !== 'number') {
			return '';
		}

		const option = this.options[index];
		return `${option.type} (${option.number})`;
	}

	chatTypeChangeHandler(index: number | undefined) {
		this.setState({
			selectedChatTypeIndex: index,
		});
	}

	get queuedChats(): _Chat[] {
		var a = sessionStorage.getItem('agentId') || '';
		let LoggedinAgentIdArray: any = [];
		LoggedinAgentIdArray.push(parseInt(a));

		let dataShow = this.props.chats.filter(
			(chat) =>
				chat.tabName === 'My Queues' &&
				!chat.botConv &&
				chat.mappedAgentIds &&
				chat.mappedAgentIds.some((r) => LoggedinAgentIdArray.indexOf(r) >= 0)
		).length;

		this.setState(
			() => {
				return {
					isqueueLength: dataShow,
				};
			},
			() => {}
		);
		return this.props.chats.filter(
			(chat) =>
				chat.tabName === 'My Queues' &&
				!chat.botConv &&
				chat.mappedAgentIds &&
				chat.mappedAgentIds.some((r) => LoggedinAgentIdArray.indexOf(r) >= 0)
		);
	}

	get acceptedChats(): _Chat[] {
		var a = sessionStorage.getItem('agentId') || '';
		let LoggedinAgentIdArray: any = [];
		LoggedinAgentIdArray.push(parseInt(a));
		return this.props.chats.filter(
			(chat) =>
				chat.tabName === 'My Chats' &&
				chat.mappedAgentIds &&
				chat.mappedAgentIds.some((r) => LoggedinAgentIdArray.indexOf(r) >= 0)
		);
	}

	get botChats(): _Chat[] {
		this.setState({
			isBotChatsLength: this.props.chats.filter((chat) => chat.botConv).length,
		});
		return this.props.chats.filter((chat) => chat.botConv);
	}

	setupCustomerListener() {
		this.socket = new WebSocket(
			WEBSOCKET_URL +
				BASE_URL +
				'/wsConnendpoint?tenantId=' +
				this.props.tenantId +
				'&timezoneOffset=' +
				new Date().getTimezoneOffset()
		); //uat
		// this.socket = new WebSocket(
		//   'wss://' +
		//     BASE_URL +
		//     '/wsConnendpoint?tenantId=' +
		//     this.props.tenantId +
		//     '&timezoneOffset=' +
		//     new Date().getTimezoneOffset()
		// ); //prod

		this.socket.onopen = () => {
			sessionStorage.setItem('wsConnendpoint', 'open');
			sessionStorage.setItem('iswsConnendpoint', 'opened');
			document.dispatchEvent(new Event('socketopened'));
			this.setState(
				{
					isSocketLoading: true,
				},
				() => {
					this.heartbeat();
				}
			);
		};

		this.socket.onmessage = this.chatListSocketListener.bind(this);
		this.socket.onclose = (ev) => {
			console.log(ev);

			if (ev.reason !== 'wsConnendpoint closing from UI') {
				this.setupCustomerListener();
			}
		};
	}
	heartbeat() {
		if (!this.socket) return;
		if (this.socket.readyState !== 1) return;
		this.socket.send(JSON.stringify({ keepalive: 'true' }));
		setTimeout(this.heartbeat, 5000);
	}

	chatListSocketListener(event: MessageEvent) {
		this.setState(
			{
				isSocketLoading: false,
			},
			() => {
				const chats: SocketChat[] = JSON.parse(event.data);

				var filterData: any = chats
					.filter((chat: SocketChat) => chat.type !== 'mycon')
					.map((chat: SocketChat) => ({
						type: chat.type ? chat.type : 'default',
						botName: chat.botName,
						botConv: chat.BotConv,
						channel: chat.channel,
						deviceInfo: chat.deviceInfo,
						pending: chat.pending,
						sessionID: chat.session,
						name: chat.customerName,
						ipaddress: chat.ipaddress,
						title: 'Cust ID ' + chat.s_id,
						timeDiff: chat.time,
						transfer: chat.isChatHistory,
						botIconURL: chat.botIconURL,
						s_id: chat.s_id,
						collectStatus: chat.collectStatus,
						isAutoassignedCalled: chat.isAutoassignedCalled,
						tabName: chat.tabName,
						queueId: chat.queueId,
						botId: chat.botId,
						customerName: chat.customerName,
						mappedAgentIds: chat.mappedAgentIds,
						botListLength: this.BotList.length,
						isTransferOrRelease: chat.isTransferOrRelease,
						lastMsg: chat.lastMsg,
						isTyping: !!chat.isTyping,
						lang: chat.lang,
						phoneNumber: chat.phoneNumber,
						emailId: chat.emailId,
						isTakeOverOptedChkFlag: chat.isTakeOverOptedChkFlag,
						calledFrom: 'agent',
					}));
				// }
				// var newfilterData: _Chat[] = filterData.filter(
				//   (chat: SocketChat) =>
				//     chat.channel !== '' && chat.channel !== null && chat.channel !== undefined
				// );

				this.props.addChats(filterData);

				var a = sessionStorage.getItem('agentId') || '';
				let LoggedinAgentIdArray: any = [];
				LoggedinAgentIdArray.push(parseInt(a));

				let dataShow = this.props.chats.filter(
					(chat) =>
						chat.tabName === 'My Queues' &&
						!chat.botConv &&
						chat.mappedAgentIds &&
						chat.mappedAgentIds.some(
							(r) => LoggedinAgentIdArray.indexOf(r) >= 0
						)
				);

				if (this.state.showQueue === true) {
					this.setState({
						prevQueueLength: this.state.isqueueLength,
						prevBotChatsLength: this.state.isBotChatsLength,
						showQueue: false,
					});
				}
				if (this.state.isqueueLength < this.state.prevQueueLength) {
					this.setState({
						prevQueueLength: this.state.isqueueLength,
					});
				}

				if (sessionStorage.getItem('agentLogin') === 'Login') {
					if (
						this.state.prevQueueLength !== this.state.isqueueLength &&
						this.state.isqueueLength > 0
					) {
						this.newhandelCutomerNotification(
							dataShow[dataShow.length - 1].type,
							dataShow[dataShow.length - 1].customerName
						);
						this.setState({
							prevQueueLength: this.state.isqueueLength,
						});
						return;
					}
				}
				if (
					localStorage.getItem('chatSessionId') &&
					this.state.selectedChatTab === 1
				) {
					this.acceptedChats.map((chat, index) => {
						if (
							localStorage.getItem('chatSessionId') ===
								this.acceptedChats[index].sessionID &&
							this.acceptedChats[index].pending > 0
						) {
							// var show =
							//   this.acceptedChats[index].channel === 'WhatsApp' ||
							//   this.acceptedChats[index].channel === 'whatsapp'
							//     ? true
							//     : false;
							this.props.selectChat(index);
							this.props.chatCoversationHistory(index);
						}
						if (this.acceptedChats[index].collectStatus === '0') {
							sessionStorage.setItem('ischatActive', 'collected');
						}
					});
				}
				if (
					localStorage.getItem('chatSessionId') &&
					this.state.selectedChatTab === 0
				) {
					this.queuedChats.map((chat, index) => {
						if (
							localStorage.getItem('chatSessionId') ===
								this.queuedChats[index].sessionID &&
							this.queuedChats[index].pending > 0
						) {
							this.props.selectChat(index);
							this.props.chatCoversationHistory(index);
						}
					});
				}
			}
		);
	}
	getBotFilter() {
		let agentId = sessionStorage.getItem('agentId');

		api(`listOfBots`, 'POST', {
			loggedInAgentId: agentId,
			tenantId: this.props.tenantId,
			screenName: 'Chats',
			tabName:
				this.state.selectedChatTab === 0
					? 'MyQueues'
					: this.state.selectedChatTab === 1
					? 'MyChats'
					: 'BotChats',
			agentSessionID: sessionStorage.getItem('agentActiveSession'),
		}).then((response) => {
			if (response.error === 'Authentication Failed') {
				this.props.redirectionToLoginPage();
			} else {
				// if (response.redirectToLogin === true) {
				// 	this.props.redirectionToLoginPage();
				// } else {
				this.setState({
					botList: response.JsonResp.map((botdata: any) => ({
						botName: botdata.botName,
						botid: botdata.botId,
						botIconUrl: botdata.botIconURL,
					})),
					botFilter: response.JsonResp.map((botdata: any) => ({
						botName: botdata.botName,
					})),
				});
			}
		});
	}
	showNotification(notificationMessage: string, name: string) {
		// console.log("notify",notificationMessage)
		new Notification(`New chat in ${'‘' + notificationMessage + '’'} queue`, {
			// body:`New chat in ${notificationMessage} queue`+'\r\n'+`${name} is waiting for an agent `
			body: `${name} is waiting for an agent `,
		});
		const audio = document.querySelector('#my_new_audio') as HTMLAudioElement;
		audio.play();
	}
	newhandelCutomerNotification(message: string, source: string) {
		this.props.clearNotificationInterval();

		if (Notification.permission === 'granted') {
			this.showNotification(message, source);

			this.props.setNotificationInterval(source, 3000);
		} else if (Notification.permission !== 'denied') {
			Notification.requestPermission().then((permission) => {
				if (permission === 'granted') {
					this.showNotification(message, source);

					this.props.setNotificationInterval(source, 3000);
				}
			});
		} else if (Notification.permission === 'denied') {
			this.props.setNotificationInterval(source, 3000);
		}
	}
	//  showTitleNotification(sender: string) {
	//    var newTitle = sender + ' says...';
	//    document.title = newTitle;
	//  }
	getQueueFilter() {
		let botid = '';
		let agentId = sessionStorage.getItem('agentId');
		if (
			this.state.botFilterSelected === '' &&
			this.state.botListSelected[0] === undefined
		) {
			botid = '';
		} else {
			botid = this.state.botListSelected[0].botid;
		}
		api(
			`listOfQueuesForMappedAgent?botId=${encodeURIComponent(
				botid
			)}&loggedInAgentId=${agentId}&tenantId=${
				this.props.tenantId
			}&agentSessionID=${sessionStorage.getItem('agentActiveSession')}`
		).then((response) => {
			let queueDetails = response.JsonResp;
			this.setState({
				queueFilter:
					queueDetails &&
					queueDetails.map((res: any) => ({
						queueId: res.queueId,
						queueName: res.queueName,
						BotAndQueueName: res.BotAndQueueName,
						status: res.status ? res.status : '',
					})),
			});
		});
	}
	get queueDataList() {
		console.log(
			this.state.queueFilter.filter((data: any) => {
				return data.status !== 'deleted';
			})
		);
		return (
			this.state.queueFilter &&
			this.state.queueFilter.filter((data: any) => {
				return data.status !== 'deleted';
			})
		);
	}
	botFilterChange = (event: any) => {
		this.setState({
			botFilterSelected: event === 'All Bots' ? '' : event,
			botListSelected:
				event === 'All Bots'
					? []
					: this.state.botList.filter((data) => data.botName === event),
		});
	};
	queuFilterChange = (event: any) => {
		this.setState({
			queueFilterSelected: event === 'All Queues' ? '' : event,
		});
	};
	get options(): ChatOption[] {
		return this.props.chats.reduce((acc: ChatOption[], curr: _Chat) => {
			const foundIndex = acc.findIndex((el) => el.type === curr.type);
			if (foundIndex >= 0) {
				let copy = JSON.parse(JSON.stringify(acc));
				copy[foundIndex] = {
					...copy[foundIndex],
					number: ++copy[foundIndex].number,
				};
				return copy;
			} else {
				return [
					...acc,
					{
						type: curr.type,
						number: 1,
					},
				];
			}
		}, []);
	}

	get allChats() {
		// debugger
		let chats: _Chat[] = [];

		switch (this.state.selectedChatTab) {
			case 0: {
				chats = this.queuedChats;
				if (chats[0]) {
					localStorage.setItem('frstQueueSessionId', chats[0].sessionID);
				}
				break;
			}
			case 1: {
				chats = this.acceptedChats;
				break;
			}
			case 2: {
				// chats = this.botChats;
				chats = this.props.allbotChats;
				// debugger
				break;
			}
			default: {
				chats = [];
			}
		}
		this.setState(
			{
				chatLength: chats.length,
				// queueData:chats
			},
			() => {
				if (chats.length) {
					this.props.showUserLoader(true);
				}
				//    console.log(this.state.chatLength)
			}
		);
		if (!chats.length) {
			let imgURL = '';
			let chatsLengthData = '';
			this.props.showUserLoader(false);
			if (this.state.isSocketLoading) {
				imgURL = Loader;
				chatsLengthData = 'Loading chats...';
				return (
					<div id='no-chats'>
						<div
							className='userdetails-loader'
							style={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								cursor: 'pointer',
								width: '100%',
								height: 'calc(80vh - 167px)',
								flexDirection: 'column',
							}}>
							<img src={Loader} alt='loader' className='loader-icon' />
							<span className='loader-content'>Loading chats...</span>
						</div>
					</div>
				);
			} else {
				switch (this.state.selectedChatTab) {
					case 0: {
						imgURL = NoUserThumbsUp;
						chatsLengthData = 'All caught up!';
						break;
					}
					case 1: {
						imgURL = NoUserChat;
						chatsLengthData = 'No started chats';
						break;
					}
					case 2: {
						imgURL = NoBotChats;
						chatsLengthData = 'Nothing much here';
						break;
					}
				}
				return (
					<div id='no-chats'>
						<img src={imgURL} alt='no-chats' />
						<div>
							<strong>{chatsLengthData}</strong>
						</div>
						<div>
							{this.state.selectedChatTab === 1 ? (
								// sessionStorage.getItem('roleId') !== '1' ? (
								<>
									Go to{' '}
									<p
										className='clickable'
										onClick={() => {
											this.setState(
												{
													selectedChatTab: 0,
													// slectedChatData: 0,
													slectedChatData: -1,
													tabsChanged: Math.random(),
													// tabsChanged:crypto.randomBytes()
												},
												() => {
													// this.props.selectChat(this.state.slectedChatData);
												}
											);
										}}>
										My Queues
									</p>{' '}
									to see <br />
									waiting users
								</>
							) : this.state.selectedChatTab === 0 ? (
								<>No users waiting</>
							) : (
								<>
									No Ongoing chats at the <br />
									moment
								</>
							)}
						</div>
					</div>
				);
			}
		} else {
			var count = 0;
			// var a = sessionStorage.getItem('agentId') || '';

			return (
				<>
					{this.state.selectedChatTab === 0 && this.queuedChats.length && (
						<div>
							{this.BotList.length > 1 && (
								<DropdownFilter
									options={this.state.botFilter.map((bot: any) => bot.botName)}
									selected={this.state.botFilterSelected}
									placeholder='Select bot to filter'
									onSelectionChange={this.botFilterChange}
									filterType='external'
									searchBot='yes'
								/>
							)}
							<DropdownFilter
								options={
									this.queueDataList &&
									this.queueDataList.map((queue: any) => queue.BotAndQueueName)
								}
								selected={this.state.queueFilterSelected}
								placeholder='Select queue to filter'
								onSelectionChange={this.queuFilterChange}
								filterType='external'
								searchBot='yes'
							/>
						</div>
					)}
					{this.state.selectedChatTab === 2 &&
						this.props.botChatsCount &&
						this.BotList.length > 1 && (
							<DropdownFilter
								options={this.state.botFilter.map((bot: any) => bot.botName)}
								selected={this.state.botFilterSelected}
								placeholder='Select bot to filter'
								onSelectionChange={this.botFilterChange}
								filterType='external'
								searchBot='yes'
							/>
						)}
					{/* <div className='ongoingchats-whole-wrapper' ref={this.myRef}> */}
					{chats &&
						chats.map((chat, index) => {
							let chatType = chat.type.replace(/GS/g, '').replace(/_M/g, ''); //nosonar
							let chatMsg = chat.lastMsg.replace(/(<([^>]+)>)/gi, ''); //nosonar
							if (
								this.state.botFilterSelected !== '' ||
								this.state.queueFilterSelected !== ''
							) {
								if (
									this.state.botFilterSelected !== '' &&
									this.state.queueFilterSelected !== ''
								) {
									if (
										this.state.botFilterSelected === chat.botName &&
										this.state.queueFilterSelected ===
											chat.botName + ':' + chatType
									) {
										return (
											<div
												key={index}
												className={
													'chat clickable' +
													(this.state.slectedChatData === index &&
													this.props.noChatsSelected === false
														? ' selected'
														: '')
												}
												onClick={() => {
													this.props.showChats(false);
													this.props.selectChat(index);
													this.props.chatCoversationHistory(index);
												}}>
												<div style={{ display: 'flex' }}>
													<div>
														{/* {chat.botIconURL && this.BotList.length > 1 && ( */}
														{chat.botIconURL && (
															<img
																src={chat.botIconURL}
																alt=''
																style={{ width: '30px', height: '30px' }}
															/>
														)}
													</div>
													<div
														style={{
															marginLeft: '8px',
															width: 'calc(100% - 38px)',
														}}>
														<div style={{ display: 'flex' }}>
															<img
																src={
																	chat.channel === 'webs'
																		? Webs_channel
																		: chat.channel === 'whatsapp' ||
																		  chat.channel === 'WhatsApp'
																		? Whatsapp_channel
																		: ''
																}
																alt=''
																style={{ width: '20px', height: '20px' }}
															/>
															{/* </div> */}
															<div
																className='title'
																style={
																	chat.isTransferOrRelease
																		? {}
																		: { marginLeft: '2px' }
																}>
																{chat.customerName}
															</div>
														</div>
														<>
															{this.state.selectedChatTab === 2 &&
															this.BotList.length > 1 ? (
																<div
																	className='type'
																	style={
																		this.BotList.length <= 1
																			? { marginLeft: '7px' }
																			: {}
																	}>
																	{this.BotList.length > 1 &&
																		chat.botName +
																			(chat.queueId !== 11111
																				? ': ' + chatType
																				: '')}
																	{chat.isTransferOrRelease ? (
																		<img
																			className='transfer'
																			src={getImage('transfer.svg')}
																			alt='transfer'
																		/>
																	) : null}
																</div>
															) : (
																this.state.selectedChatTab !== 2 && (
																	<div
																		className='type'
																		style={
																			this.BotList.length <= 1
																				? { marginLeft: '7px' }
																				: {}
																		}>
																		{this.BotList.length === 1 &&
																		this.state.queueFilter.length === 1
																			? chatType
																			: chat.botName +
																			  (chat.queueId !== 11111
																					? ': ' + chatType
																					: '')}
																		{chat.isTransferOrRelease ? (
																			<img
																				className='transfer'
																				src={getImage('transfer.svg')}
																				alt='transfer'
																			/>
																		) : null}
																	</div>
																)
															)}
														</>
														<div
															style={
																this.BotList.length <= 1
																	? {
																			display: 'flex',
																			fontSize: '14px',
																			// marginLeft: '8px',
																			color: 'rgba(0,0,0,0.6)',
																			lineHeight: '1.36',
																			marginTop: '6px',
																	  }
																	: {
																			display: 'flex',
																			fontSize: '14px',
																			// marginLeft: '37px',
																			color: 'rgba(0,0,0,0.6)',
																			lineHeight: '1.36',
																			marginTop: '6px',
																	  }
															}>
															<span
																style={
																	chatMsg ===
																		'Bot: Customer disconnected from the chat' ||
																	chatMsg === 'Bot: Agent has ended the chat'
																		? {
																				color: '#ef4078',
																				textOverflow: 'ellipsis',
																				overflow: 'hidden',
																				width: '100%',
																		  }
																		: {
																				textOverflow: 'ellipsis',
																				overflow: 'hidden',
																				width: '85%',
																				whiteSpace: 'nowrap',
																		  }
																}>
																{chatMsg}
															</span>
														</div>
													</div>
													<div>
														{this.state.selectedChatTab !== 2 && (
															<div className='time'>
																{getTimeDiff(chat.timeDiff)}
															</div>
														)}
														{chat.pending &&
														this.state.selectedChatTab !== 0 ? (
															<div className='pending'>{chat.pending}</div>
														) : null}
													</div>
												</div>
											</div>
										);
									} else {
										count++;
										if (count === chats.length) {
											return (
												<div
													style={{
														display: 'flex',
														flex: 1,
														justifyContent: 'center',
													}}>
													No results
												</div>
											);
										}
									}
								} else {
									if (
										this.state.botFilterSelected === chat.botName ||
										this.state.queueFilterSelected ===
											chat.botName + ':' + chatType
									) {
										// {
										//   console.log(
										//     this.state.slectedChatData === index &&
										//       this.props.noChatsSelected === false
										//   );
										// }
										return (
											<div
												key={index}
												className={
													'chat clickable' +
													// this.state.slectedChatData === index &&
													(this.state.slectedChatData === index &&
													this.props.noChatsSelected === false
														? ' selected'
														: '')
												}
												onClick={() => {
													this.props.showChats(false);
													this.props.selectChat(index);
													this.props.chatCoversationHistory(index);
												}}>
												<div style={{ display: 'flex' }}>
													<div>
														{chat.botIconURL && (
															<img
																src={chat.botIconURL}
																alt=''
																style={{ width: '30px', height: '30px' }}
															/>
														)}
													</div>
													<div
														style={{
															marginLeft: '8px',
															width: 'calc(100% - 38px)',
														}}>
														<div style={{ display: 'flex' }}>
															<img
																src={
																	chat.channel === 'webs'
																		? Webs_channel
																		: chat.channel === 'whatsapp' ||
																		  chat.channel === 'WhatsApp'
																		? Whatsapp_channel
																		: ''
																}
																alt=''
																style={{ width: '20px', height: '20px' }}
															/>
															<div
																className='title'
																style={
																	chat.isTransferOrRelease
																		? {}
																		: { marginLeft: '2px' }
																}>
																{chat.customerName}
															</div>
														</div>
														<>
															{this.state.selectedChatTab === 2 &&
															this.BotList.length > 1 ? (
																<div
																	className='type'
																	style={
																		this.BotList.length <= 1
																			? { marginLeft: '7px' }
																			: {}
																	}>
																	{this.BotList.length > 1 &&
																		chat.botName +
																			(chat.queueId !== 11111
																				? ': ' + chatType
																				: '')}
																	{chat.isTransferOrRelease ? (
																		<img
																			className='transfer'
																			src={getImage('transfer.svg')}
																			alt='transfer'
																		/>
																	) : null}
																</div>
															) : (
																this.state.selectedChatTab !== 2 && (
																	<div
																		className='type'
																		style={
																			this.BotList.length <= 1
																				? { marginLeft: '7px' }
																				: {}
																		}>
																		{this.BotList.length === 1 &&
																		this.state.queueFilter.length === 1
																			? chatType
																			: chat.botName +
																			  (chat.queueId !== 11111
																					? ': ' + chatType
																					: '')}
																		{chat.isTransferOrRelease ? (
																			<img
																				className='transfer'
																				src={getImage('transfer.svg')}
																				alt='transfer'
																			/>
																		) : null}
																	</div>
																)
															)}
														</>
														<div
															style={
																this.BotList.length <= 1
																	? {
																			display: 'flex',
																			fontSize: '14px',
																			// marginLeft: '8px',
																			color: 'rgba(0,0,0,0.6)',
																			lineHeight: '1.36',
																			marginTop: '6px',
																	  }
																	: {
																			display: 'flex',
																			fontSize: '14px',
																			// marginLeft: '37px',
																			color: 'rgba(0,0,0,0.6)',
																			lineHeight: '1.36',
																			marginTop: '6px',
																	  }
															}>
															<span
																style={
																	chatMsg ===
																		'Bot: Customer disconnected from the chat' ||
																	chatMsg === 'Bot: Agent has ended the chat'
																		? {
																				color: '#ef4078',
																				textOverflow: 'ellipsis',
																				overflow: 'hidden',
																				width: '100%',
																		  }
																		: {
																				textOverflow: 'ellipsis',
																				overflow: 'hidden',
																				width: '85%',
																				whiteSpace: 'nowrap',
																		  }
																}>
																{chatMsg}
															</span>
														</div>
													</div>
													<div>
														{this.state.selectedChatTab !== 2 && (
															<div className='time'>
																{getTimeDiff(chat.timeDiff)}
															</div>
														)}
														{chat.pending &&
														this.state.selectedChatTab !== 0 ? (
															<div className='pending'>{chat.pending}</div>
														) : null}
													</div>
												</div>
											</div>
										);
									} else {
										count++;
										if (count === chats.length) {
											return (
												<div
													style={{
														display: 'flex',
														flex: 1,
														justifyContent: 'center',
													}}>
													No results
												</div>
											);
										}
									}
								}
							} else {
								return (
									<div
										key={index}
										className={
											'chat clickable' +
											// this.state.slectedChatData === index &&

											(this.state.slectedChatData === index &&
											// this.state.selectedBotChatIndex === index &&
											this.props.noChatsSelected === false
												? ' selected'
												: '')
										}
										onClick={() => {
											// console.log('clicked botchats');
											this.props.showChats(false);

											this.props.chatCoversationHistory(index);
											this.props.selectChat(index);
											this.handleBotChatClick(
												index,
												chat.type,
												chat.title,
												chat.pending,
												chat.botName,
												chat.botConv,
												chat.ipaddress,
												chat.botIconURL,
												chat.s_id,
												chat.collectStatus,
												chat.tabName,
												chat.queueId,
												chat.botId,
												chat.customerName,
												chat.isTransferOrRelease,
												chat.lastMsg,
												chat.channel,
												chat.deviceInfo,
												chat.isTyping,
												chat.lang,
												chat.phoneNumber,
												chat.emailId,
												chat.isTakeOverOptedChkFlag,
												chat.session,
												chat.time
											);
										}}>
										<div style={{ display: 'flex' }}>
											<div>
												{chat.botIconURL && (
													<img
														src={chat.botIconURL}
														alt=''
														style={{ width: '30px', height: '30px' }}
													/>
												)}
											</div>
											<div
												style={{
													marginLeft: '8px',
													width: 'calc(100% - 38px)',
												}}>
												<div style={{ display: 'flex' }}>
													<img
														src={
															chat.channel === 'webs'
																? Webs_channel
																: chat.channel === 'whatsapp' ||
																  chat.channel === 'WhatsApp'
																? Whatsapp_channel
																: ''
														}
														alt=''
														style={{ width: '20px', height: '20px' }}
														// title={chat.channel === 'webs' ? 'Web' : chat.channel === 'whatsapp' ? 'WhatsApp' :chat.channel}
														title={
															chat.channel === 'webs' &&
															(chat.deviceInfo === null ||
																chat.deviceInfo === '-' ||
																chat.deviceInfo === '' ||
																chat.deviceInfo === undefined)
																? 'Web'
																: chat.channel === 'webs'
																? `Web ${
																		chat.deviceInfo !== null ||
																		chat.deviceInfo !== '' ||
																		chat.deviceInfo !== undefined
																			? '(' + chat.deviceInfo + ')'
																			: ''
																  }`
																: chat.channel === 'whatsapp'
																? 'WhatsApp'
																: chat.channel
														}
													/>
													<div
														className='title'
														style={
															chat.isTransferOrRelease
																? {}
																: { marginLeft: '2px' }
														}>
														{chat.customerName}
													</div>
												</div>
												<>
													{this.state.selectedChatTab === 2 &&
													this.BotList.length > 1 ? (
														<div
															className='type'
															style={
																this.BotList.length <= 1
																	? { marginLeft: '7px' }
																	: {}
															}>
															{this.BotList.length > 1 &&
																chat.botName +
																	(chat.queueId !== 11111
																		? ': ' + chatType
																		: '')}
															{chat.isTransferOrRelease ? (
																<img
																	className='transfer'
																	src={getImage('transfer.svg')}
																	alt='transfer'
																/>
															) : null}
														</div>
													) : (
														this.state.selectedChatTab !== 2 && (
															<div
																className='type'
																style={
																	this.BotList.length <= 1
																		? { marginLeft: '7px' }
																		: {}
																}>
																{this.BotList.length === 1 &&
																this.state.queueFilter.length === 1
																	? chatType
																	: chat.botName +
																	  (chat.queueId !== 11111
																			? ': ' + chatType
																			: '')}
																{chat.isTransferOrRelease ? (
																	<img
																		className='transfer'
																		src={getImage('transfer.svg')}
																		alt='transfer'
																	/>
																) : null}
															</div>
														)
													)}
												</>
												<div
													style={
														this.BotList.length <= 1
															? {
																	display: 'flex',
																	fontSize: '14px',
																	// marginLeft: '8px',
																	color: 'rgba(0,0,0,0.6)',
																	lineHeight: '1.36',
																	marginTop: '6px',
															  }
															: {
																	display: 'flex',
																	fontSize: '14px',
																	// marginLeft: '37px',
																	color: 'rgba(0,0,0,0.6)',
																	lineHeight: '1.36',
																	marginTop: '6px',
															  }
													}>
													{chat.isTyping ? (
														<div className='user-typing'>User is typing…</div>
													) : (
														<div
															className='user-message'
															style={
																chatMsg ===
																	'Bot: Customer disconnected from the chat' ||
																chatMsg === 'Bot: Agent has ended the chat'
																	? {
																			color: '#ef4078',
																			textOverflow: 'ellipsis',
																			overflow: 'hidden',
																			width: '100%',
																	  }
																	: {
																			textOverflow: 'ellipsis',
																			overflow: 'hidden',
																			width: '85%',
																			whiteSpace: 'nowrap',
																	  }
															}>
															{chatMsg}
														</div>
													)}
												</div>
											</div>
											<div>
												{this.state.selectedChatTab !== 2 ? (
													<div className='time'>
														{getTimeDiff(chat.timeDiff)}
													</div>
												) : (
													<div className='time'>{getTimeDiff(chat.time)}</div>
												)}
												{/* {chat.pending ? ( */}
												{chat.pending && this.state.selectedChatTab !== 2 ? (
													<div className='pending'>{chat.pending}</div>
												) : null}
											</div>
										</div>
									</div>
								);
							}
						})}
					{/* </div> */}
					{this.state.selectedChatTab === 2 &&
					this.props.botChatsCount &&
					this.BotList.length > 1 ? (
						<div className='overall-refresh-popup'>
							<div
								className='refresh-round-button'
								title='Refresh'
								onClick={() => {
									this.props.setbotsChatsPage();
								}}>
								<img
									src={refreshImage}
									alt='refreshimage'
									style={{
										width: '24px',
										height: '24px',
									}}
								/>
							</div>
						</div>
					) : null}
				</>
			);
		}
	}
	get BotList() {
		return this.state.botFilter.filter((data: any) => {
			return data !== 'All Bots';
		});
	}

	handleMyChatsTypeSelectionChange(e: any) {
		if (e === 1) {
			fetchedPageNumber = 0;
			this.setState(
				{
					myChatsTypeSelected: 'Ended chats',
					oldChatsPage: 1,
					groupOldData: false,
				},
				() => {
					this.props.showChats(true);
					this.props.setIsEndedChatsSelected(true);
					this.getOldChats(this.state.oldChatsPage, false);
					var filterElements = Array.from(
						document.getElementsByClassName(
							'ended-chat-filter-image'
						) as HTMLCollectionOf<HTMLElement>
					);
					if (this.state.clearDateFilterValue === true) {
						filterElements[0].style.backgroundColor = ' #fff';
					} else {
						filterElements[0].style.backgroundColor = ' #ef4078';
					}
				}
			);
		} else {
			this.setState(
				{
					selectedOldChatIndex: `-1`,
					myChatsTypeSelected: 'Ongoing chats',
				},
				() => {
					this.props.showChats(true);
					this.props.setIsEndedChatsSelected(false);
				}
			);
		}
	}
	clearDateFilter() {
		this.setState(
			{
				noDataShow: 'data stored',
			},
			() => {
				this.props.showEndedChatData(this.state.noDataShow);
			}
		);
		fetchedPageNumber = 0;
		this.setState(
			{
				oldChats: [],
				startDate: this.state.initialstartDate,
				endDate: this.state.initialendDate,
				clearDateFilterValue: true,
				oldChatsPage: 1,
				groupOldData: false,
				selectedOldChatIndex: -1,
			},
			() => {
				this.props.showChats(true);
				this.props.setIsEndedChatsSelected(true);
				this.getOldChats(this.state.oldChatsPage, false);
				var filterElements = Array.from(
					document.getElementsByClassName(
						'ended-chat-filter-image'
					) as HTMLCollectionOf<HTMLElement>
				);
				filterElements[0].style.backgroundColor = ' #fff';
			}
		);
	}
	groupAll(val: boolean) {
		this.setState({
			groupOldData: val,
		});
	}
	enddateSelection(start: Moment, end: Moment, selected: any) {
		fetchedPageNumber = 0;
		this.setState(
			{
				oldChats: [],
				startDate: start,
				endDate: end,
				clearDateFilterValue: false,
				oldChatsPage: 1,
				selectedOldChatIndex: -1,
				selectedDate: selected,
			},
			() => {
				this.props.showChats(true);
				this.props.setIsEndedChatsSelected(true);
				this.getOldChats(this.state.oldChatsPage, false);
			}
		);
	}

	endedChatcleanDate(date: Moment, toLocal?: any) {
		if (!toLocal) {
			return this.moment.utc(date).format('YYYY-MM-DD HH:mm:ss');
		}

		var utcMoment = this.moment.utc(date);
		var utcDate = new Date(utcMoment.format());

		return (
			utcDate.getFullYear() +
			'-' +
			(utcDate.getMonth() + 1) +
			'-' +
			utcDate.getDate() +
			' ' +
			utcDate.getHours() +
			':' +
			utcDate.getMinutes() +
			':' +
			utcDate.getSeconds()
		);
	}
	endedChatgetUTCData() {
		var today = new Date();
		var startTime, endTime, todayStartTime, todayEndTime;
		var yesterday = new Date();
		yesterday.setDate(yesterday.getDate() - 1);
		// console.log(this.state.startDate.format('YYYY-MM-DD'),this.moment(today).format('YYYY-MM-DD'))
		if (this.state.selectedDate === 'Today') {
			todayStartTime =
				today.getFullYear() +
				'-' +
				(today.getMonth() + 1) +
				'-' +
				today.getDate() +
				' 00:00:00';
			todayEndTime =
				today.getFullYear() +
				'-' +
				(today.getMonth() + 1) +
				'-' +
				today.getDate() +
				' 23:59:59';
			startTime = this.endedChatcleanDate(
				this.moment(todayStartTime, 'YYYY-MM-DD HH:mm:ss')
			);
			endTime = this.endedChatcleanDate(
				this.moment(todayEndTime, 'YYYY-MM-DD HH:mm:ss')
			);
		} else if (this.state.selectedDate === 'Yesterday') {
			var yesterdayStartTime =
				yesterday.getFullYear() +
				'-' +
				(yesterday.getMonth() + 1) +
				'-' +
				yesterday.getDate() +
				' 00:00:00';
			// yesterday.setDate(yesterday.getDate() - 1);
			var yesterdayEndTime =
				yesterday.getFullYear() +
				'-' +
				(yesterday.getMonth() + 1) +
				'-' +
				yesterday.getDate() +
				' 23:59:59';
			startTime = this.endedChatcleanDate(
				this.moment(yesterdayStartTime, 'YYYY-MM-DD HH:mm:ss')
			);
			endTime = this.endedChatcleanDate(
				this.moment(yesterdayEndTime, 'YYYY-MM-DD HH:mm:ss')
			);
		} else {
			// var fullYear= this.state.startDate.format('YYYY-MM-DD')[0]
			var newStartTime =
				this.state.startDate.format('YYYY-MM-DD') + ' 00:00:00';
			// yesterday.setDate(yesterday.getDate() - 1);
			var newEndTime = this.state.endDate.format('YYYY-MM-DD') + ' 23:59:59';

			startTime = this.endedChatcleanDate(
				this.moment(newStartTime, 'YYYY-MM-DD HH:mm:ss')
			);
			endTime = this.endedChatcleanDate(
				this.moment(newEndTime, 'YYYY-MM-DD HH:mm:ss')
			);
		}
		return startTime + '::' + endTime;
	}

	getOldChats(page: number, appendOldChats: boolean) {
		const agentId = sessionStorage.getItem('agentId');

		if (fetchedPageNumber < page && agentId) {
			fetchedPageNumber = page;
			const loggedInAgentId = parseInt(agentId);

			this.setState(
				{
					isOldChatsLoading: true,
				},
				() => {
					fetch(
						HTTP_URL +
							BASE_URL +
							`/getAgentsOldChats?loggedInAgentId=${loggedInAgentId}&timezoneOffset=${new Date().getTimezoneOffset()}&page=${page}&start=${
								this.endedChatgetUTCData().split('::')[0]
							}&end=${this.endedChatgetUTCData().split('::')[1]}&tenantId=${
								this.props.tenantId
							}&agentSessionID=${sessionStorage.getItem('agentActiveSession')}`
					)
						.then((r) => r.json())
						.then((response) => {
							if (response) {
								const groups = response.reduce((groups: any[], data: any) => {
									const date = data.time.split(' ')[0];
									if (!groups[date]) {
										groups[date] = [];
									}
									groups[date].push(data);
									return groups;
								}, []);
								const datesArray = Object.keys(groups);
								const groupArrays = datesArray.map((date) => {
									return {
										[date]: groups[date],
									};
								});
								if (this.state.oldChats.length) {
									let lastDateChats =
										this.state.oldChats[this.state.oldChats.length - 1];
									const firstDateChats = groupArrays[0];
									const lastDateChatsKey = Object.keys(lastDateChats); // ["2021-08-09"]
									const fisrtDateChatsKey = Object.keys(firstDateChats); // ["2021-08-09"]
									if (lastDateChatsKey[0] === fisrtDateChatsKey[0]) {
										lastDateChats[lastDateChatsKey[0]] = [
											...lastDateChats[lastDateChatsKey[0]],
											...firstDateChats[fisrtDateChatsKey[0]],
										];
										groupArrays.shift();
									}
								}
								const updatedChats = [...this.state.oldChats, ...groupArrays];
								this.setState(
									{
										oldChats: appendOldChats ? updatedChats : groupArrays,
										isOldChatsLoading: false,
										oldChatsPage: page + 1,
										oldChatsExhausted:
											Array.isArray(groupArrays) && groupArrays.length === 0,
									},
									() => {
										sessionStorage.setItem(
											'pageCount',
											JSON.stringify(this.state.oldChatsPage)
										);
										if (page === 1) {
											const firstData = this.state.oldChats;
											this.setState({
												data: [],
											});
											var promise = require('promise');

											const firstChat = async () =>
												Object.values(firstData).map(
													async (key: any, d: any) => {
														firstData[d][Object.keys(key)[0]] &&
															firstData[d][Object.keys(key)[0]].map(
																async (o: any, i: number) => {
																	if (d === 0 && i === 0) {
																		this.setState(
																			{
																				data: firstData[0][
																					Object.keys(key)[0]
																				][0],
																			},
																			() => {
																				if (this.state.data !== undefined) {
																					this.setState({
																						chatLength:
																							this.state.oldChats.length,
																					});
																				}
																			}
																		);

																		return firstData[0];
																	}
																	await Promise.all(firstData);
																}
															);
													},
													[]
												);

											if (firstData !== undefined && firstData.length > 0) {
												firstChat();
											} else {
												this.setState(
													{
														noDataShow: '',
													},
													() => {
														this.props.showEndedChatData(this.state.noDataShow);
														this.props.userDetails.userName = '';
														this.props.userDetails.userEmail = '';
														this.props.userDetails.userContact = '';
														this.props.userDetails.userSource = '';
														this.props.userDetails.sessionId = '';
														this.props.userDetails.feedbackComment = '';
														this.props.userDetails.time = '';
													}
												);
											}
										}
									}
								);
							}
						})
						.catch((e) => {
							console.log(e);
							// this.setState({
							//   isOldChatsLoading: false,
							// });
						});
				}
			);
		}
		// }
	}

	handleEndedChatClick(
		index: number | any,
		sessionID: string,
		ipaddress: string,
		s_id: number,
		botIconUrl: string,
		botName: string,
		customerName: string,
		type: string | null,
		status: string,
		feedback?: string,
		channel?: string,
		deviceInfo?: string,
		handoff_id?: string,
		time?: string
	) {
		this.props.showChats();
		this.setState(
			{
				selectedOldChatIndex: index,
			},
			() => {
				//  console.log(this.state.selectedOldChatIndex)
			}
		);
		document.dispatchEvent(
			new CustomEvent('endedchatclick', {
				detail: {
					sessionID,
					ipaddress,
					s_id,
					botIconUrl,
					botName,
					customerName,
					type,
					status,
					feedback,
					channel,
					deviceInfo,
					handoff_id,
					time,
				},
			})
		);
		//  console.log("handel",time);
	}

	handleBotChatClick(
		index: number,
		type: string,
		title: string,
		pending: number,
		botName: string,
		botConv: string,
		ipaddress: string,
		botIconURL: string,
		s_id: string,
		collectStatus: string,
		tabName: string,
		queueId: number,
		botId: string,
		customerName: string,
		isTransferOrRelease: boolean,
		lastMsg: string,
		channel: string,
		deviceInfo: string,
		isTyping?: boolean,
		lang?: string,
		phoneNumber?: string,
		emailId?: string,
		isTakeOverOptedChkFlag?: boolean,
		session?: string,
		time?: string
	) {
		// this.props.showChats(false);
		this.setState(
			{
				selectedBotChatIndex: index,
			},
			() => {
				// console.log(this.state.selectedBotChatIndex, customerName);
			}
		);
		document.dispatchEvent(
			new CustomEvent('botchatclick', {
				detail: {
					index,
					type,
					title,
					pending,
					botName,
					botConv,
					ipaddress,
					botIconURL,
					s_id,
					collectStatus,
					tabName,
					queueId,
					botId,
					customerName,
					isTransferOrRelease,
					lastMsg,
					channel,
					deviceInfo,
					isTyping,
					lang,
					phoneNumber,
					emailId,
					isTakeOverOptedChkFlag,
					session,
					time,
				},
			})
		);

		//  console.log("handel",time);
	}

	render() {
		return (
			<div className='chat-tab-wrapper'>
				<div className='header'>
					<div
						className={
							'panel clickable' +
							(this.state.selectedChatTab === 1 ? ' selected' : '')
						}
						onClick={() => {
							this.setState(
								{
									selectedChatTab: 1,
									// slectedChatData: 0,
									slectedChatData: -1,
									tabsChanged: Math.random(),
									// tabsChanged:crypto.randomBytes()
								},
								() => {
									this.props.showChats(true);
									this.props.setIsBotChatsSelected(false);
									this.props.setchatTab(this.state.selectedChatTab);
									// this.props.selectChat(this.state.slectedChatData);
								}
							);
						}}>
						My chats
						{this.acceptedChats.length ? (
							<div
								className={
									'pending red' +
									(this.state.selectedChatTab === 1 ? ' on-selected' : '')
								}>
								{this.acceptedChats.length}
							</div>
						) : null}
					</div>
					{/* {sessionStorage.getItem('roleId') !== '1' && ( */}
					<div
						className={
							'panel clickable' +
							(this.state.selectedChatTab === 0 ? ' selected' : '')
						}
						onClick={() => {
							this.setState(
								{
									selectedChatTab: 0,
									// slectedChatData: 0
									slectedChatData: -1,
								},
								() => {
									this.props.showChats(true);
									this.props.setIsBotChatsSelected(false);
									this.props.setchatTab(this.state.selectedChatTab);
									this.props.setIsEndedChatsSelected(false);
									//  this.getQueueFilter(); //added now
									// this.props.selectChat(this.state.slectedChatData);
								}
							);
						}}>
						My queues
						{this.queuedChats.length ? (
							<div
								className={
									'pending red' +
									(this.state.selectedChatTab === 0 ? ' on-selected' : '')
								}>
								{this.queuedChats.length}
							</div>
						) : null}
					</div>
					{/* )} */}
					<div
						className={
							'panel clickable' +
							(this.state.selectedChatTab === 2 ? ' selected' : '')
						}
						onClick={() => {
							this.setState(
								{
									selectedChatTab: 2,
									//  slectedChatData: 0,
									slectedChatData: -1,
									tabsChanged: Math.random(),

									// tabsChanged:crypto.randomBytes()
								},
								() => {
									this.props.setIsBotChatsSelected(true);
									this.props.setbotsChatsPage();
									this.props.showChats(true);
									this.getBotFilter();
									this.getQueueFilter();
									this.props.setchatTab(this.state.selectedChatTab);
									this.props.setIsEndedChatsSelected(false);
								}
							);
						}}>
						Bot chats
						{this.props.botChatsCount ? (
							<div
								className={
									'pending red' +
									(this.state.selectedChatTab === 2 ? ' on-selected' : '')
								}>
								{this.props.botChatsCount}
							</div>
						) : null}
					</div>
				</div>
				{this.state.selectedChatTab === 1 ? (
					<div className='filter-area'>
						<DropdownFilter
							selected={this.state.myChatsTypeSelected}
							options={['Ongoing chats', 'Ended chats']}
							placeholder='Select Chat Type'
							onSelectionChange={this.handleMyChatsTypeSelectionChange}
							filterType='external'
							startDate={this.state.startDate}
							endDate={this.state.endDate}
							enddateSelection={this.enddateSelection}
							clearDateFilterValue={this.state.clearDateFilterValue}
							notificationToaster={this.props.notificationToaster}
						/>
					</div>
				) : null}

				{this.state.myChatsTypeSelected === 'Ended chats' ? (
					<EndedChats
						oldChats={this.state.oldChats}
						clearDateFilterValue={this.state.clearDateFilterValue}
						selectedOldChatIndex={this.state.selectedOldChatIndex}
						getGroupingFormatDate={this.props.getGroupingFormatDate}
						isOldChatsLoading={this.state.isOldChatsLoading}
						clearDateFilter={this.clearDateFilter}
						oldChatsExhausted={this.state.oldChatsExhausted}
						onPageChange={() => this.getOldChats(this.state.oldChatsPage, true)}
						onClick={this.handleEndedChatClick}
						groupAll={this.groupAll}
					/>
				) : (
					<div className='chats' ref={this.myRef}>
						{this.allChats}
					</div>
				)}
				<audio id='my_new_audio' src={require('../assets/audio/queue.mp3')} />
			</div>
		);
	}
}
